import { render, staticRenderFns } from "./PaymentRequestCredit.vue?vue&type=template&id=049475e1&scoped=true&"
import script from "./PaymentRequestCredit.vue?vue&type=script&lang=js&"
export * from "./PaymentRequestCredit.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequestCredit.vue?vue&type=style&index=0&id=049475e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049475e1",
  null
  
)

export default component.exports